<template>
  <div>
    <el-form :inline="true" :model="form" size="mini" class="demo-form-inline backborder1">
      <el-form-item label="单号获取时间">
        <el-date-picker v-model="form.timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">搜索</el-button>
      </el-form-item>
    </el-form>

    <div class="backborder2" style="margin-top:10px">
      <el-table :data="tableData" style="width: 100%" border size="mini">
        <el-table-column prop="logistics_name" label="快递公司" />
        <el-table-column label="占用快递单号(个)">
          <template slot-scope="scope">
            <el-button type="text" @click="openOccupationRecord(scope.row)">
              {{ scope.row.occupy_total }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="回收快递单号(个)">
          <template slot-scope="scope">
            <el-button type="text" @click="openRecyclingRecords(scope.row)">
              {{ scope.row.recycle_total }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: flex-end;padding: 10px;">
        <el-pagination @size-change="queryPageSizeChange" @current-change="queryPageCurrentChange" :current-page="form.p"
          :page-sizes="[10, 20, 50]" :page-size="form.rollpage" layout="total, sizes, prev, pager, next, jumper"
          :total="form.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '/Sellshippingbirld/index',
      form: {
        timeRange: [],
        start_time: '',
        end_time: '',
        rollpage: 10, // 每页显示条数
        p: 1,   // 当前页码
        total: 0
      },
      tableData: [
        // 示例数据
        { expressCompany: '顺丰', occupiedNumbers: 100, recycledNumbers: 50 },
        { expressCompany: '圆通', occupiedNumbers: 150, recycledNumbers: 70 }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.form.timeRange && this.form.timeRange.length) {
        this.form.start_time = this.form.timeRange[0];
        this.form.end_time = this.form.timeRange[1];
      } else {
        this.form.start_time = '';
        this.form.end_time = '';
      }
      this.$axios({
        url: this.url,
        method: 'POST',
        data: {
          act: 'generate_waybill_statistics',
          ...this.form
        }
      })
        .then(res => {
          this.tableData = res.Data;
          this.form.total = parseInt(res.count);
        });
    },
    queryPageSizeChange(val) {
      this.form.rollpage = val;
      this.getList();
    },
    queryPageCurrentChange(val) {
      this.form.p = val;
      this.getList();
    },
    openOccupationRecord() {
      this.$emit('listenchild', { name: '使用记录', url: 'ExpressDeliveryUsage', data: { sellid: 0 } });
    },
    openRecyclingRecords() {
      this.$emit('listenchild', { name: '回收记录', url: 'ExpressRecycling', data: { sellid: 0 } });
    }
  }
};
</script>

<style scoped>
/* 添加一些样式 */
.demo-form-inline {
  margin-bottom: 20px;
}

.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 3% 1%
}
</style>


// WEBPACK FOOTER //
// src/components/home/ExpressStatistics.vue